import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// Layout
import MainLayout from './components/MainLayout';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ApplicationForm from './pages/ApplicationForm';
import TrackApplication from './pages/TrackApplication';
import ParentResults from './pages/ParentResults';
import PrimaryAdmissionForm from './pages/PrimaryAdmissionForm';
import FeeStructure from './pages/FeeStructure';
import SchoolRules from './pages/SchoolRules';

// Admin Pages
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Reports from './pages/Reports';
import PrimaryReports from './pages/PrimaryReports';
import Students from './pages/Students';
import TeacherMarksEntry from './pages/TeacherMarksEntry';
import PrimaryTeacherMarksEntry from './pages/PrimaryTeacherMarksEntry';
import PrivateRoute from './components/PrivateRoute';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a237e',
      light: '#534bae',
      dark: '#000051',
    },
    secondary: {
      main: '#ff6f00',
      light: '#ff9e40',
      dark: '#c43e00',
    },
    background: {
      default: '#f4f7fb',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 700 },
    h2: { fontSize: '2rem', fontWeight: 700 },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <Router>
          <Routes>
            {/* Public Pages wrapped in uniform MainLayout */}
            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
            <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
            <Route path="/apply" element={<MainLayout><ApplicationForm /></MainLayout>} />
            <Route path="/track" element={<MainLayout><TrackApplication /></MainLayout>} />
            <Route path="/results" element={<MainLayout><ParentResults /></MainLayout>} />
            <Route path="/primary/apply" element={<MainLayout><PrimaryAdmissionForm /></MainLayout>} />
            <Route path="/fees" element={<MainLayout><FeeStructure /></MainLayout>} />
            <Route path="/rules" element={<MainLayout><SchoolRules /></MainLayout>} />
            <Route path="/admin/login" element={<MainLayout hideFooter={false}><AdminLogin /></MainLayout>} />

            {/* Protected Admin Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/reports"
              element={
                <PrivateRoute>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/students"
              element={
                <PrivateRoute>
                  <Students />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/marks-entry"
              element={
                <PrivateRoute>
                  <TeacherMarksEntry />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/primary-reports"
              element={
                <PrivateRoute>
                  <PrimaryReports />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/primary-marks-entry"
              element={
                <PrivateRoute>
                  <PrimaryTeacherMarksEntry />
                </PrivateRoute>
              }
            />

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
